"use client";
import { createContext, useContext } from "react";

export type Customer = {
  id: string;
  nombre: string;
  telefono?: string;
  email?: string;
  rfc?: string;
};

export type CustomerContextValue = {
  customer: Customer | null;
  setCustomer: (c: Customer | null) => void;
};

export const CustomerContext = createContext<CustomerContextValue | undefined>(undefined);

export function useCustomerContext() {
  const ctx = useContext(CustomerContext);
  if (!ctx) throw new Error("useCustomerContext must be used within CustomerProvider");
  return ctx;
}
